<div class="image"
  [style.background-image]="'url(' + (imageUrl ? imageUrl : ('/assets/images/products/' + projectPropertyName.toLowerCase() + 's/' + projectProperty.code + '.jpg')) + ')'">
  @if (enlargedImageUrl) {
    <div class="zoom-control-container">
      <button (click)="openZoomDialog()"
        mat-mini-fab color="tertiary">
        <mat-icon svgIcon="magnify-plus"></mat-icon>
      </button>
    </div>
  }
  <span>
    {{ title ? title : '' }}
    @if (projectPropertyName === 'bag') {
      <span class="sub-title">
        for artwork up to {{project.size }}
      </span>
    }
  </span>
</div>
<div class="back-button-container">
  <button (click)="backButtonClicked()"
          mat-flat-button color="secondary">
    <mat-icon svgIcon="chevron-left"></mat-icon>
    Go Back
  </button>
</div>
